import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import { styleCss } from './AdminUsers.styles';
import {
  addUserAction,
  getOrgSitesAction,
  getUserAction
} from '../../reducers/actions';
import { USER_PERMISSIONS_LIST } from '../../constants/users';

import AdminTitleBar from '../../components/common/admintitlebar/AdminTitleBar';
import ErrorBoundary from '../../components/common/errorboundary/ErrorBoundary';
import Modal from '../../components/common/modal/Modal';
import AddUserForm from '../../components/forms/adduserform/AddUserForm';
import UserRow from '../../components/data/users/userRow';
import { getSelectedSite } from './util';
import { isValid } from '../../utils/validation';
import Error from '../../components/common/errorBanner/error';

export class AdminUsers extends Component {
  constructor(props) {
    super(props);
    const { sites } = props;

    let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
    let currentSite =
      sites.find(site => site.value === currentSiteId) || sites[0];
    this.state = {
      showAddUserModal: false,
      dropdownValue: (currentSite && currentSite.value) || '',
      users: this.props.getUser(currentSiteId) || [],
      isAdminUser: false
    };
    this.onSiteChange = this.onSiteChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.users !== prevProps.users) {
      this.setState({isAdminUser: this.isAdminUser()});
    }
  }

  componentDidMount() {
    //this.props.getOrgSites(localStorage.getItem('orgId'))
  }
  //as we are making call on componentDidMount, it will change the props(componentWillReceiveProps called) n we need to set the dropdown value in the state
  componentWillReceiveProps(nextProps) {
    //old n new not equal and the array is not empty then set
    const { sites } = nextProps;
    let currentSite = getSelectedSite(sites) || sites[0];
    if (this.props.sites.length !== sites.length && currentSite) {
      this.setState({ dropdownValue: currentSite.value });
    }

    if (this.props.users !== nextProps.users && nextProps.users[0]) {
      this.setState({ users: nextProps.users });
    }
  }

  onSiteChange(newSite) {
    const site = newSite && newSite.value;
    this.setState(
      { dropdownValue: site, isAdminUser: this.isAdminUser() },
      () => this.props.getUser(site),
      localStorage.setItem(`airfinder_selected_site`, site)
    );
  }

  handleAdd = () => {
    this.setState({ showAddUserModal: true });
  };

  handleAddClose = () => {
    this.setState({
      showAddUserModal: false
    });
  };

  handleSubmit = values => {
    values.account = this.props.account.id;
    const site = getSelectedSite(this.props.sites).value;
    values.sitePermissions = [site];
    this.props.addUser(values);
    this.props.resetForm('adduser');
    this.handleAddClose();
  };

  orgSet=()=> {
    return localStorage.getItem("orgId") ? true : false;
  }
  

  isAdminUser= () => {
    const isAdmin = ['superadmin','admin'].indexOf(this.props.orgUserRole) > -1 && this.orgSet();
    if(isAdmin){
      return isAdmin;
    }

    const currentUserEmail = localStorage.getItem('email');
    const isSiteAdmin = this.props.users.some(usr=>
       (usr !== undefined && usr.data.assetInfo.metadata.props.email === currentUserEmail && usr.data.assetInfo.metadata.props.Admin === 'true') 
    );
    
    return isSiteAdmin;
  };

  render() {
    const { sites, errorMessage } = this.props;
    let siteOpts = sites.map(s=>{
      return (<option value={s.value} key={s.value}>{s.label}</option>)
    })
    return (
      <div className={css(styleCss.base)}>
        {isValid(errorMessage) && <Error msg={errorMessage} />}
        <ErrorBoundary>
          <AdminTitleBar
            title={I18n.t('admin.users')}
            handleAdd={this.handleAdd}
          />
          <select
            className={`${css(styleCss['user-site-select'])} ui-dropdown ui-widget ui-state-default ui-corner-all ui-helper-clearfix`}
            name="input-name"            
            value={this.state.dropdownValue}
            onChange={e => this.onSiteChange(e.target)}>
            {siteOpts}
          </select>
        </ErrorBoundary>
        <ErrorBoundary>
          <content className={css(styleCss.content)}>
            {this.state.users
              .filter(function(user) {
                return user !== undefined;
              })
              .map((user, index) => (
                <UserRow key={user.data.id} user={user} isAdmin={this.state.isAdminUser}  />
              ))}
          </content>
        </ErrorBoundary>

        <Modal
          isOpen={this.state.showAddUserModal}
          onRequestClose={this.handleAddClose}
          contentLabel="Add User Modal"
          title={I18n.t('add.addUser')}
        >
          <AddUserForm
            onSubmit={this.handleSubmit}
            sitetobeShown={getSelectedSite(sites)}
            userPermissions={this.props.userPermissions}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {organizations: { orgUserRole }}=state;
  const sites = state.sites.list.map(site => {
    return {
      label: site.name,
      value: site.id
    };
  });
  const userPermissions = USER_PERMISSIONS_LIST.map(permission => {
    return {
      label: permission,
      value: permission
    };
  });
  return {
    account: state.auth.account,
    sites,
    orgUserRole,
    userPermissions,
    users: state.users.users,
    errorMessage: state.errorBanner.errorMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetForm() {
      dispatch(reset(...arguments));
    },
    addUser() {
      dispatch(addUserAction(...arguments));
    },
    getSites() {
      dispatch(getOrgSitesAction(...arguments));
    },
    getOrgSites(orgid){
      dispatch(getOrgSitesAction(orgid))
    },
    getUser(id) {
      dispatch(getUserAction(id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminUsers);



// WEBPACK FOOTER //
// ./src/containers/adminusers/AdminUsers.js